export const CommissionTransactionTypes = {
  Payment: 'payment',
  Payout: 'payout',
  Refund: 'refund',
  Chargeback: 'chargeback',
} as const;
